import React, { useEffect, useState } from 'react'
import UserCourse from './UserCourse';
import UserCertificate from './UserCertificate';
import { useLocation } from 'react-router-dom';
import { learnerDashboardRes, learnerDashboardTodo } from '../../LMS_Redux/LMS_Slices/Dashboard/LearnerDashboard';
import { useDispatch, useSelector } from 'react-redux';
import TimeSpending from '../LMS_GRAPHS/TimeSpending';
import CourseStatistics from '../LMS_GRAPHS/CourseStatistics';
import { PropagateLoader } from 'react-spinners';
import { BsArrowDownCircle, BsArrowUpCircle } from 'react-icons/bs';
import AllActivities from '../LMS_GRAPHS/AllActivities';
import UpcomingTrainings from '../LMS_GRAPHS/UpcomingTrainings';
import { learnerBadgeTodo, learnerBadgeRes } from '../../LMS_Redux/LMS_Slices/Dashboard/LearnerBadge'
import LearnerBadge from '../LMS_DASHBOARD/LearnerBadge';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { pointsDetailsRes, pointsDetailsTodo } from '../../LMS_Redux/LMS_Slices/LeaderBoard/PointsDetails';
import { ListGroup } from 'react-bootstrap';

export default function UserReport() {

    const { state } = useLocation()
    const dispatch = useDispatch()
    const graph = useSelector(state => state.learnerDashboard && state.learnerDashboard.data && state.learnerDashboard.data.data)
    const badge = useSelector(state => state.learnerBadge && state.learnerBadge.data && state.learnerBadge.data.data)
    const points = useSelector(state => state.pointsDetails && state.pointsDetails.data && state.pointsDetails.data.data)
    const [loading, setLoading] = useState(true)
    const [loadingBadge, setLoadingBadge] = useState(true)
    const [loadingPoints, setLoadingPoints] = useState(true)
    // console.log(state.vemp_code)

    const graph_res = () => {
        if (learnerDashboardRes && learnerDashboardRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const badge_res = () => {
        if (learnerBadgeRes && learnerBadgeRes.success) {
            setLoadingBadge(false)
        } else {
            setLoadingBadge(false)
        }
    }

    const points_res = () => {
        if (pointsDetailsRes && pointsDetailsRes.success) {
            setLoadingPoints(false)
        } else {
            setLoadingPoints(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        setLoadingBadge(true)
        setLoadingPoints(true)
        dispatch(learnerDashboardTodo(state.vemp_code)).then(() => graph_res())
        dispatch(learnerBadgeTodo(state.vemp_code)).then(() => badge_res())
        dispatch(pointsDetailsTodo(state.vemp_code)).then(() => points_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>User Report</span>
                </div>

                <div className='row'>
                    <div className='col-md-3'>
                        <div className='box'>
                            <div className="profile-left">
                                <div className="image-area">
                                    <img className="user-image" src={state?.vimage_name} onError={(e) => { e.target.src = "./Images/profile.jpg" }} />

                                </div>
                                <div className="info-area">
                                    <h6>{state && state.vemp_fname}</h6>
                                    <p>{state && state.vdesignation_name}</p>

                                </div>
                                <div className="profile-numbers">
                                    <div className="single-number">
                                        <span className="number-detail">Learning Modules</span>
                                        <span className="number">{graph && graph.course_count}</span>
                                    </div>

                                    <div className="single-number">
                                        <span className="number-detail">Groups</span>
                                        <span className="number">{graph && graph.group_count}</span>
                                    </div>

                                    <div className="single-number">
                                        <span className="number-detail">Trainings</span>
                                        <span className="number">{graph && graph.training_count}</span>
                                    </div>
                                </div>
                                <div className="profile-info">
                                    <div className="single-profile-info ">
                                        <h6>Organization</h6>
                                        <p>{state && state.vbusiness_area_name ? state.vbusiness_area_name : '-'}</p>
                                    </div>
                                    <div className="single-profile-info ">
                                        <h6>Department</h6>
                                        <p>{state && state.vdepartment_name ? state.vdepartment_name : '-'}</p>
                                    </div>
                                    <div className="single-profile-info ">
                                        <h6>Reporting Manager</h6>
                                        <p>-</p>
                                    </div>
                                    <div className="single-profile-info ">
                                        <h6>Contact No.</h6>
                                        <p>{state && state.vmobile_no ? state.vmobile_no : '-'}</p>
                                    </div>
                                    <div className="single-profile-info">
                                        <h6>Email</h6>
                                        <p><a href='#' >{state && state.vemail ? state.vemail : '-'}</a></p>
                                    </div>



                                </div>
                                <div className="profile-tabs">
                                    <div className="nav flex-column nav-pills mb-sm-0 mb-3 mx-auto" id="v-border-pills-tab" role="tablist" aria-orientation="vertical">
                                        <a className="nav-link active" id="v-border-pills-home-tab" data-bs-toggle="pill" href="#v-border-pills-home" role="tab" aria-controls="v-border-pills-home" aria-selected="true">Home</a>
                                        <a className="nav-link" id="v-border-pills-team-tab" data-bs-toggle="pill" href="#v-border-pills-team" role="tab" aria-controls="v-border-pills-team" aria-selected="false">Learning Modules</a>
                                        <a className="nav-link" id="v-border-pills-orders-tab" data-bs-toggle="pill" href="#v-border-pills-orders" role="tab" aria-controls="v-border-pills-orders" aria-selected="false">Certificates</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='col-md-9'>
                        <div className="tab-area-content">

                            <div className="tab-content" id="v-border-pills-tabContent">

                                <div className="tab-pane fade show active" id="v-border-pills-home" role="tabpanel" aria-labelledby="v-border-pills-home-tab">
                                    <div className="row row-flex">

                                        <div className="col-12 col-md-6 mb-4">
                                            {loadingBadge ?
                                                <div className="wrapper-admin">
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className="wrapper-admin">
                                                    <div className='dash_head'>
                                                        <h5>Badges</h5>
                                                    </div>
                                                    <PerfectScrollbar options={{ suppressScrollX: true }} style={{ height: '25vh' }}>
                                                        <LearnerBadge badge={badge} />
                                                    </PerfectScrollbar>
                                                </div>
                                            }
                                        </div>

                                        <div className="col-12 col-md-6 mb-4">
                                            {loadingPoints ?
                                                <div className="wrapper-admin">
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className="wrapper-admin">
                                                    <div className='dash_head'>
                                                        <h5>Point Detail's</h5>
                                                    </div>
                                                    <PerfectScrollbar options={{ suppressScrollX: true }} style={{ height: '25vh' }}>
                                                        <ListGroup as="ol" >
                                                            {points && points.userPoints && points.userPoints.map((val, index) =>
                                                                <ListGroup.Item
                                                                    as="li"
                                                                    className="d-flex justify-content-between align-items-center"
                                                                    key={index}
                                                                >
                                                                    <div className="fw-bold" style={{ color: 'rgba(34, 98, 198, 0.4)' }}>{index + 1}</div>
                                                                    <div className="ms-4 me-auto">
                                                                        <div className="">{val && val.lms_master_point && val.lms_master_point.point_type}</div>
                                                                        {val && val.user && val.user.vdepartment_name}
                                                                    </div>
                                                                    <div className="fw-bold" style={{ color: '#2262C6' }}>{val && val.point_sum}</div>
                                                                </ListGroup.Item>
                                                            )}
                                                        </ListGroup>
                                                    </PerfectScrollbar>
                                                </div>
                                            }
                                        </div>

                                        <div className="col-12 col-md-6">
                                            {loading ?
                                                <div className="wrapper-admin">
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className='wrapper-admin match_height'>
                                                    <TimeSpending graph={graph && graph.time_spending} />

                                                    <div className="d-flex align-items-center">
                                                        <div className="p-2 ">
                                                            <BsArrowUpCircle size={20} className='me-3' style={{ color: 'green' }} />
                                                        </div>
                                                        <div className="p-2 flex-grow-1">
                                                            <span className="font-15" style={{ fontWeight: '600' }}>Most Time</span>
                                                            {/* <p className="mb-0 font-12 text-muted">Wednesday</p> */}
                                                        </div>
                                                        <div className="p-2">
                                                            <span className="font-13 float-right mt-1 text-info">{graph && graph.most_time}</span>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center">
                                                        <div className="p-2 ">
                                                            <BsArrowDownCircle size={20} className='me-3' style={{ color: 'red' }} />
                                                        </div>
                                                        <div className="p-2 flex-grow-1">
                                                            <span className="font-15" style={{ fontWeight: '600' }}>Less Time</span>
                                                            {/* <p className="mb-0 font-12 text-muted">Wednesday</p> */}
                                                        </div>
                                                        <div className="p-2">
                                                            <span className="font-13 float-right mt-1 text-danger">{graph && graph.less_time}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            }
                                        </div>
                                        <div className="col-12 col-md-6 mt-4 mt-md-0">
                                            <div className='wrapper-admin match_height'>
                                                {loading ?
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                    :
                                                    <CourseStatistics graph={graph && graph.course_statistics} />
                                                }
                                            </div>
                                        </div>

                                    </div>

                                    <div className="row row-flex mt-4">
                                        <div className="col-12 col-md-6">
                                            {loading ?
                                                <div className="wrapper-admin">
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className='match_height'>
                                                    <AllActivities graph={graph && graph.all_activities} />
                                                </div>
                                            }
                                        </div>

                                        <div className="col-12 col-md-6">
                                            {loading ?
                                                <div className="wrapper-admin">
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className='match_height'>
                                                    <UpcomingTrainings graph={graph && graph.upcoming_training} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="v-border-pills-team" role="tabpanel" aria-labelledby="v-border-pills-team-tab">
                                    <UserCourse user_id={state.vemp_code} />
                                </div>

                                <div className="tab-pane fade" id="v-border-pills-orders" role="tabpanel" aria-labelledby="v-border-pills-orders-tab">
                                    <UserCertificate user_id={state.vemp_code} />
                                </div>

                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
